(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-topbar"] && !Shopify.designMode) return;
  try {
    
  class SpLanguageDropdown extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-sp-lang-button]');
      this.panel = this.querySelector('[data-sp-lang-panel]');
      if (!this.button || !this.panel) return;
      this.button.addEventListener('click', this.toggle);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    toggle = () => {
      if (this.panel.hidden) this.open();
      else this.close();
    };

    open() {
      this.panel.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keyup', this.onKeyUp);
    }

    close() {
      this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keyup', this.onKeyUp);
    }

    onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };

    onKeyUp = (event) => {
      if (event.key !== 'Escape') return;
      this.close();
      this.button.focus();
    };
  }

  if (!customElements.get('sp-language-dropdown')) {
    customElements.define('sp-language-dropdown', SpLanguageDropdown);
  }

  } catch(e) { console.error(e); }
})();
})();
